import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';

// Controls
import { Tooltip, Icons } from '@gpstrackit/gtc-react-controls';

// Helpers
import { GetFormatForMoment } from 'Core/data/Helpers';

// Gadget keys that have no date filter
const NO_DATE_FILTER_GADGETS = [
    'CasesCoachingSummary',
    'PendingCoachingCase',
    'ActiveCoachingCases',
    'DriverPerformanceCoach',
];

const GadgetDateInfo = ({ filters, gadgetkey }) => {
    const { messages } = useIntl();
    const user = useSelector(state => state.securityRedux.user);

    const hasDateFilter = filters?.timeFrame
        && filters?.rangeDate?.start && filters?.rangeDate?.end;

    let tooltipText = '';
    let iconColor = '#005bf8';

    if (hasDateFilter) {
        const dateFormat = GetFormatForMoment(user?.dateformat) || 'MM/DD/YYYY';
        const timeFrameLabel = messages[`driver_performance_events_${filters.timeFrame}`] || filters.timeFrame;
        const startFormatted = moment(filters.rangeDate.start).format(`${dateFormat} hh:mm a`);
        const endFormatted = moment(filters.rangeDate.end).format(`${dateFormat} hh:mm a`);
        tooltipText = `${timeFrameLabel} (${startFormatted} - ${endFormatted})`;
    } else {
        tooltipText = messages[`gadget_date_info_${gadgetkey}`] || messages['gadget_date_info_all_records'] || 'All records (no date filter applied)';
        iconColor = '#FF9800';
    }

    return (
        <Tooltip placement="bottom" title={tooltipText}>
            <span
                className="no-drag"
                style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
            >
                <Icons name="info" size="small" style={{ color: iconColor }} />
            </span>
        </Tooltip>
    );
};

export default GadgetDateInfo;
